module.exports = "pegasus/assets/preview-9.png";